module.exports = __webpack_public_path__ + "media/images/front/treatment_support/mv_appeal-254f3da90b074932278b7b4a841405a3.png";